import { useEffect, useState } from 'react'
import { X } from 'lucide-react'
import { subscribeToasts, toast, type ToastItem } from '../lib/toast'

export function Toaster() {
  const [items, setItems] = useState<ToastItem[]>([])
  useEffect(() => subscribeToasts(setItems), [])
  if (items.length === 0) return null
  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2" role="status" aria-live="polite">
      {items.map((t) => (
        <div
          key={t.id}
          className={`flex items-start gap-3 rounded-lg px-4 py-3 text-sm shadow-lg max-w-md ${
            t.kind === 'error' ? 'bg-red-600 text-white' : 'bg-emerald-600 text-white'
          }`}
        >
          <span className="flex-1">{t.message}</span>
          <button onClick={() => toast.dismiss(t.id)} aria-label="Schliessen" className="shrink-0 opacity-80 hover:opacity-100">
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  )
}
